import { render, staticRenderFns } from "./EditorialStaffPager.vue?vue&type=template&id=6ccaed11&"
import script from "./EditorialStaffPager.vue?vue&type=script&lang=js&"
export * from "./EditorialStaffPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ccaed11')) {
      api.createRecord('6ccaed11', component.options)
    } else {
      api.reload('6ccaed11', component.options)
    }
    module.hot.accept("./EditorialStaffPager.vue?vue&type=template&id=6ccaed11&", function () {
      api.rerender('6ccaed11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/editorial-staff-pager/EditorialStaffPager.vue"
export default component.exports